module.exports = __webpack_public_path__ + "static/media/7_cumsefolosestamasca.a9f6e99f.jpg";